import React, {useState} from 'react';
import * as CandidateService from '@app/services/CandidateService';
import {toast} from 'react-toastify';
import '../styles.css';
import {cloneDeep} from 'lodash';
import {Checkbox} from '@components';
import ProcessExtractResult from '@pages/candidate/userinput/ProcessExtractResult';
import ProcessExtractResultModal from '@pages/candidate/userinput/ProcessExtractResultModal';

const CreatePerson = (props) => {
    const [exportExcelFlg, setExportExcelFlg] = useState(false);
    const [isFormInput, setIsFormInput] = useState(true);
    const [cvFailedList, setCVFailedList] = useState([]);
    const [processRefCheckResult, setProcessRefCheckResult] = useState([]);
    const [candidates, setCandidates] = useState([{
        checkedExists: false
    }]);

    let {refererInfo, onFinishCheckExists} = props
    if (!refererInfo && props.location && props.location.search) {
        const refererInfoParams = new URLSearchParams(props.location.search).get("refererInfo")
        if (refererInfoParams) {
            refererInfo = JSON.parse(decodeURIComponent(refererInfoParams))
        }
    }

    return (
        <div className='container-fluid'>
            {/*<div className='card card-primary'>*/}
            {/*    <div className='card-header'>*/}
            {/*        <h3 className='card-title'>Nhập mẩu thông tin</h3>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {candidates && candidates.length > 0 &&
            <ProcessExtractResult
                isShow={processRefCheckResult.length === 0}
                candidateList={candidates}
                cvFailedList={cvFailedList}
                isExportExcel={exportExcelFlg}
                hasInputCommon={candidates.length > 1}
                isFormInput={isFormInput}
                refererInfo={refererInfo}
                onFinishCheckExists={onFinishCheckExists}
                onProcessRefCheckResult={(result) => setProcessRefCheckResult([result])}
            />
            }

            {processRefCheckResult.length > 0 &&
            <ProcessExtractResultModal extractResults={processRefCheckResult}
                                       isShow={processRefCheckResult.length > 0}
                                       onClose={() => setProcessRefCheckResult([])}/>
            }
        </div>
    );
};

export default CreatePerson;
